/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentPlanType/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Insurance from './Insurance/index'
import No from './No/index'
import Person from './Person/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PaymentPlanType({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsEditAutopay/Content/SourceInvoice/PaymentPlanType"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let editAutopayInfoPaymentPlanPaymentPlanTypeValueData = fromData.useDataValue({ viewPath,
context: 'edit_autopay_info',
path: 'payment_plan.payment_plan_type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: editAutopayInfoPaymentPlanPaymentPlanTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Insurance'}>
<Insurance
  viewPath={`${viewPath}/Insurance`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Person'}>
<Person
  viewPath={`${viewPath}/Person`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}